module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Pause-895ac01304f7f0df062befedfa50f758.svg";